export default __webpack_public_path__ + "bf8a9d9da6157ce523ffebb8693ec59b.png";